import React from "react"
import styled, { keyframes } from "styled-components"
import breakpoint from "styled-components-breakpoint"

import { DrupalLink } from "../../utils/drupal"
import Pill from "@ui-kit/atoms/button/pill"

const TwoCol = ({ pid }) => {
  const nodes = []
  const paragraph = nodes.find((n) => n.pid === pid)

  if (paragraph === undefined) {
    return <span />
  }

  const theme = paragraph?.relationships.theme
    ? paragraph.relationships.theme.name
    : "primary"

  return (
    <Style tint={theme}>
      {paragraph.title && <h2>{paragraph.title}</h2>}

      <div className="promotion__body">
        {paragraph.body && (
          <article dangerouslySetInnerHTML={{ __html: paragraph.body.html }} />
        )}
      </div>
      {paragraph.link &&
        paragraph.link.map((link) => (
          <p key={link.title}>
            <DrupalLink to={link.uri}>
              <Pill coloured elem="span">
                {link.title}
              </Pill>
            </DrupalLink>
          </p>
        ))}
    </Style>
  )
}

export default TwoCol
/*
const query = graphql`
  query {
    paragraphs: allParagraphTwoColumnPromotionLargeTitle {
      nodes {
        pid: drupal_internal__id
        title: field_title
        body: field_body {
          html: processed
        }
        link: field_link {
          uri
          title
        }

        relationships {
          theme: field_theme {
            name
          }

          image: field_image {
            meta: field_media_image {
              alt
              width
              height
            }
            relationships {
              image: field_media_image {
                handheld: localFile {
                  childImageSharp {
                    fluid(
                      maxWidth: 480
                      maxHeight: 480
                      quality: 80
                      cropFocus: ATTENTION
                    ) {
                      ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                  }
                }
                desktop: localFile {
                  childImageSharp {
                    fluid(maxWidth: 1000, quality: 80) {
                      ...GatsbyImageSharpFluid_withWebp_noBase64
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
*/
const Style = styled.div.attrs((props) => ({
  className: `promotion promotion--two-col-large-title`,
}))`
  text-align: center;
  background-color: var(--light);
  width: 100%;
  max-width: 90vw;
  margin-left: auto;
  margin-right: auto;
  padding: 4vw 2vw;
  padding: 4vmax 2vmax;
  margin-top: -2.5vmin !important;
  box-shadow: 0 0 1.5vw rgba(0, 0, 0, 0.35);
  border-radius: 0.5em;
  margin-bottom: 1vh;

  ${breakpoint("sm")`
        padding: 4vw 6vw;
        padding: 4vmax 6vmax;
        margin-top: -10vh!important;
        margin-top: -10vmin!important;
        margin-bottom: 0;
        opacity: 0;
        transform: translateY(4vh);
        animation-name: ${keyframes`
            0% {
                opacity: 0;
                transform: translateY(4vh);
            }
            100% {
                opacity: 1;
                transform: translateY(0);
            }
        `};
        animation-fill-mode: forwards;
        animation-duration: .45s;
        animation-iteration-count: 1;
    `}

  ${breakpoint("xlg")`
        max-width: 1200px;
        margin-top: -8vh!important;
        margin-top: -8vmin!important;
    `}

    > h2 {
    color: ${(props) => props.theme.colors[props.tint]};
    font-size: calc(1.5em + 1.75vw);
  }

  .promotion__body {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas: "image" "body";
    grid-template-rows: auto;
    grid-gap: 5vw 0;
    margin-top: calc(${(props) => props.theme.gutter} * 0.65);
    text-align: left;

    ${breakpoint("md")`
            grid-template-columns: 1fr 1fr;
            grid-template-areas: "image body";
            grid-template-rows: 1fr;
            grid-gap: 0 5vmax;
        `}

    + p {
      margin-top: calc(${(props) => props.theme.gutter} * 0.75);
    }

    h2,
    h3 {
      font-family: Newzald Bold Italic;
      font-weight: normal;
      font-size: 32px;
    }

    .lead {
      font-size: 130%;
    }

    figure,
    img {
      margin-bottom: 0;
    }

    article {
      grid-area: body;
      align-self: center;
    }

    .promotion__image {
      grid-area: image;
    }
  }
`
